import KKioskHeader from "./components/App/KKiosk/KKioskHeader";
import KNav from "./components/App/KNav/KNav";
import KNetworkDownToolbar from "./components/App/KToolbar/KNetworkDownToolbar";
import KSiteUpdate from "./components/App/KSiteUpdate/KSiteUpdate";
import KToasts from "./components/App/KToasts/KToasts";
import KToolbar from "./components/App/KToolbar/KToolbar";
import KView from "./components/App/KView/KView";
import { Notifiable } from "kinnect-mixins";
import { VApp } from "vuetify/lib";

export default {
	name: "app",

	metaInfo: { titleTemplate: titleChunk => ( titleChunk ? `${titleChunk} | Kinnect` : "Kinnect" ) },

	mixins: [ Notifiable ],

	computed: {
		dark() {
			return this.$store.state.app.dark;
		},

		idUser() {
			return this.$store.getters["auth/userID"];
		},

		isKiosk() {
			return this.$store.state.kiosk.isKiosk;
		},

		genPageElements() {
			if ( this.isKiosk ) {
				return [
					<KNetworkDownToolbar></KNetworkDownToolbar>,
					<KKioskHeader></KKioskHeader>,
					<KView></KView>
				];
			}

			return [
				<KNetworkDownToolbar></KNetworkDownToolbar>,
				<KNav></KNav>,
				<KToasts></KToasts>,
				<KSiteUpdate></KSiteUpdate>,
				<KToolbar></KToolbar>,
				<KView></KView>
			];
		}
	},

	watch: {
		idUser: {
			handler( idUser ) {
				if ( this.$ga ) {
					this.$ga.set( "userId", idUser ? idUser : null );
				}
			},
			immediate: true
		},

		dark: {
			handler( val ) {
				this.$vuetify.theme.dark = val;
			},
			immediate: true
		},

		isKiosk: {
			handler( val ) {
				if ( val ) {
					document.documentElement.classList.add( "kiosk-mode" );
				} else {
					document.documentElement.classList.remove( "kiosk-mode" );
				}
			},
			immediate: true
		}
	},

	created() {
		this.$store.dispatch( "oneSignal/updateIdDevice" );
	},

	render() {
		return <VApp dark={this.dark}>{this.genPageElements}</VApp>;
	}
};
